/** HTTP poll helpers for useTaskStream (exported for unit tests). */

export const TERMINAL_TASK_STATUSES = new Set(["completed", "failed", "cancelled", "partial_failure"]);

/** Slow backstop poll while WebSocket is connected. */
export const HTTP_POLL_INTERVAL_WS_LIVE_MS = 10_000;

/** Faster poll when WebSocket is down. */
export const HTTP_POLL_INTERVAL_MS = 3000;

export function idsNeedingHttpPoll(
  taskIds: string[],
  statuses: Record<string, { status?: string } | undefined>,
): string[] {
  return taskIds.filter((id) => {
    const status = statuses[id]?.status;
    if (status && TERMINAL_TASK_STATUSES.has(status)) return false;
    return true;
  });
}

export function httpPollIntervalMs(wsLive: boolean, fallbackIntervalMs: number = HTTP_POLL_INTERVAL_MS): number {
  return wsLive ? HTTP_POLL_INTERVAL_WS_LIVE_MS : fallbackIntervalMs;
}

/** Clamp task progress for UI (API may briefly report >100 on legacy tasks). */
export function clampTaskProgress(progress: number | null | undefined): number {
  if (progress == null || Number.isNaN(progress)) return 0;
  return Math.min(100, Math.max(0, Math.round(progress)));
}
